<template>
  <div>
    <v-tabs v-model="tab">
      <v-tab v-for="user in getUserList" :key="user.id">{{ user.nickname }}</v-tab>
      <v-tab v-if="showAddUser()" key="_tabnew">
        <v-icon dark color="primary">mdi-account-multiple-plus</v-icon>
      </v-tab>
      <v-tabs-slider></v-tabs-slider>
      <v-tab-item v-for="user in getUserList" :key="user.id">
        <UserCard @editing-state-change="OnEditingStateChange" :user="user" />
      </v-tab-item>
      <v-tab-item>
        <AddUser v-on:user-added="OnUserAdded" v-on:user-added-cancel="OnUserAddedCancel" />
      </v-tab-item>
    </v-tabs>
  </div>
</template>
<script>
import UserCard from "@/components/UserCard";
import AddUser from "@/components/AddUser";
import { mapGetters } from "vuex";
export default {
  name: "UserTabs",
  components: { UserCard, AddUser },
  computed: {
    ...mapGetters(["getUserList", "getUserTimeSeries"])
  },
  data: () => ({ tab: 0, simplified: true }),
  methods: {
    showAddUser() {
      const userList = this.getUserList;
      if (userList && userList.length == 1) {
        const userId = userList[0].id;
        if (this.getUserTimeSeries(userId).length === 0) {
          return false;
        }
      }
      return true;
    },

    OnEditingStateChange(e) {
      if (e) {
        this.stopUpdater();
      } else {
        this.startUpdater();
      }
    },
    OnUserAdded(user) {
      this.$store.dispatch("addUser", user); // goto last tab
      this.tab = this.getUserList.length;
    },
    OnUserAddedCancel() {
      this.tab = 0;
      this.$emit("user-added-cancel");
    },
    startUpdater() {
      this.$store.commit("REFRESH_UPDATE", Date.now());
      const autoUpdaye = 60;
      this.updater = setInterval(() => {
        this.$store.commit("REFRESH_UPDATE", Date.now());
      }, autoUpdaye * 1000);
    },
    stopUpdater() {
      if (this.updater) {
        clearInterval(this.updater);
        this.updater = null;
      }
    }
  },
  mounted() {
    this.startUpdater();
  },
  beforeDestroy() {
    this.stopUpdater();
  }
};
</script>
